import type { Visualization, Settings } from './types'
import { VisualizationManager } from './core/visualization-manager'
import { EventBus } from './core/event-bus'

export class GeoPieMap {
  private readonly manager: VisualizationManager
  private readonly eventBus: EventBus = EventBus.getInstance()

  constructor (element: HTMLElement) {
    this.manager = new VisualizationManager(element)
  }

  public initialize (settings: Settings): void {
    this.manager.initialize(settings)
  }

  public render (visualization: Visualization): void {
    this.manager.render(visualization)
  }

  public on (event: string, callback: (...args: any[]) => void): () => void {
    return this.eventBus.subscribe(event, callback)
  }

  public publish (event: string, data: any): void {
    this.eventBus.publish(event, data)
  }
}
